module.exports = __webpack_public_path__ + "static/media/uk.330b4363.svg";